import { LogLevel } from "@azure/msal-browser";
import { env } from "./env/env";

export const msalConfig = {
	auth: {
		clientId: env.azureClientId,
		authority: env.azureAuthority,
		navigateToLoginRequestUrl: false,
	},
	cache: {
		cacheLocation: "sessionStorage",
		storeAuthStateInCookie: false,
	},
	system: {
		loggerOptions: {
			loggerCallback: (
				level: number,
				message: string,
				containsPii: boolean,
			) => {
				if (containsPii) {
					return;
				}
				switch (level) {
					case LogLevel.Error:
						console.error(message);
						return;
					case LogLevel.Info:
						// console.info(message);
						return;
					case LogLevel.Verbose:
						// console.debug(message);
						return;
					case LogLevel.Warning:
						// console.warn(message);
						return;
					default:
						return;
				}
			},
		},
	},
};

export const loginRequest = {
	scopes: ["Files.ReadWrite.All", "User.Read"],
};
